import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AppStateI {
    logos: any;
    isFetching: boolean,
};

type LogoItemPayloadT = {
    clientId: number,
    src: any;
};

const initialState: AppStateI = {
    logos: {},
    isFetching: false,
};


export const clientLogoSlice = createSlice({
    name: 'clientLogo',
    initialState,
    reducers: {
        addLogo: (state, action: PayloadAction<LogoItemPayloadT>) => {
            state.logos[action.payload.clientId] = action.payload.src;
        },
        toggleLogoFetching: (state) => {
            state.isFetching = !state.isFetching;
        },
    }
});

export const { addLogo, toggleLogoFetching } = clientLogoSlice.actions;

export default clientLogoSlice.reducer;